<template>
	<fragment>
		<portal to="modal" v-if="fullPage && !testing" :order="portalOrder">
			<div
				id="overlay-backdrop"
				:class="['overlay-backdrop', fullPage && 'is-full-page']"
				:style="{ zIndex: zIndex }"
				@click="onClick"
				v-show="loadedFilters"
			>
				<slot />
			</div>
		</portal>
		<div
			v-else
			id="overlay-backdrop"
			class="overlay-backdrop"
			:style="{ zIndex: zIndex }"
			@click="onClick"
		>
			<slot ref="content" />
		</div>
	</fragment>
</template>

<script>
export default {
	name: 'OverlayBackdrop',
	props: {
		fullPage: {
			type: Boolean,
			default: true
		},
		zIndex: {
			// custom z-index of the backdrop
			type: Number,
			default: 12000 // This value corresponds with $z-level6: 12000;
		},
		portalOrder: {
			type: Number,
			default: 1
		},
		loadedFilters: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		onClick(e) {
			const target = e.target;
			const el = document.getElementById('overlay-backdrop');

			if (el === target) {
				this.$emit('click');
			}
		}
	},
	computed: {
		testing() {
			return process.env.NODE_ENV === 'test';
		}
	}
};
</script>

<style lang="scss" scoped>
/******* Backdrop *******/

.overlay-backdrop {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: $backdrop-bg;
	-webkit-transition: opacity 400ms ease-in;
	-moz-transition: opacity 400ms ease-in;
	transition: opacity 400ms ease-in;
	display: flex;
	opacity: 1;
	pointer-events: auto;

	&.is-full-page {
		position: fixed;
		height: 100vh;
	}
}
</style>
